import { Link } from "@gromia/components/Link";
import { Container } from "@gromia/components/ui/Grid";
import { useSticky } from "@gromia/components/ui/Sticky";
import { useLayoutConfig } from "@gromia/components/useLayoutConfig";
import * as React from "react";
// import { useMedia } from '@gromia/utils/useMedia';
import logo from "@gromia/components/svg/logo-white.svg";
import logoRed from "@gromia/components/svg/logo.svg";
import * as s from "@gromia/components/theme/t.module.css";
import { Svg0294PhoneCallRinging } from "@gromia/picons/0294PhoneCallRinging";
import { isEnabled, useFeatures, whenEnabled } from "@gromia/utils/useFeatures";
import { createGlobalState } from "@gromia/utils/useGlobalState";
import { globalHistory } from "@reach/router";
import cx from "classnames";
import * as spriv from "./Header.module.css";
const G = createGlobalState<number>(72);
export const HeaderHeightProvider = G.Provider;
export const useHeaderHeight = G.useGlobalState;

export function HeaderItem(props: { children: React.ReactElement }) {
  return (
    <li className={cx(s.navItem)}>
      {React.cloneElement(props.children, {
        className: cx(s.navLink, spriv.navLink),
        activeClassName: spriv.navLinkActive,
      })}
    </li>
  );
}

export function HeaderLastItem(props: {
  children: NonNullable<React.ReactNode>;
}) {
  return <li className={cx(s.navItem, spriv.navItemLast)}>{props.children}</li>;
}

type Props = {
  alwaysLight?: boolean;
  disableSticky?: boolean;
  disableLinks?: boolean;
  disablePhone?: boolean;
};

export function Header(props: Props) {
  const [isOpen, setOpen] = React.useState(false);
  const config = useLayoutConfig();
  const features = useFeatures();
  const sticky = useSticky({
    top: 0,
    zIndex: 4,
    disabled: props.disableSticky,
  });

  // G.useGlobalEffect(() => 72, []);
  const whiteVersion = props.alwaysLight || sticky.isSticky || isOpen;

  const logoImage = (
    <img
      src={whiteVersion ? logoRed : logo}
      alt="Gromia "
      className={cx(s.my3, s.myLg2)}
      style={{ maxHeight: 36 }}
    />
  );

  return sticky.render(
    <header
      className={cx(
        spriv.header,
        whiteVersion ? s.shadow : null,
        whiteVersion ? null : spriv.bgTransparent,
      )}
    >
      <Container>
        <nav
          className={cx(
            s.navbar,
            s.navbarExpandLg,
            spriv.navbar,
            props.disableLinks ? s.justifyContentBetween : null,
          )}
        >
          <span className={cx(s.navbarBrand, s.p0)}>
            <Link to="/">{logoImage}</Link>
          </span>
          {props.disableLinks
            ? null
            : <Navigation isOpen={isOpen} setOpen={setOpen} />}
          {!props.disablePhone
              && (props.disableLinks || isEnabled(features.header.showPhone))
            ? (
              <a
                className={cx(
                  s.dNone,
                  s.dLgInlineFlex,
                  s.alignItemsCenter,
                  s.justifyContentCenter,
                  s.fontSizeLarge1,
                  s.fontWeightBold,
                  whiteVersion ? s.textPrimary : s.textWhite,
                )}
                href={`tel:${config.phoneLandlineValue}`}
              >
                <Svg0294PhoneCallRinging
                  className={cx(s.dNone, s.dSmInline, s.mr2, s.strokeWidth2)}
                  size={20}
                />
                {config.phoneLandlineLabelShort}
              </a>
            )
            : null}
        </nav>
      </Container>
    </header>,
  );
}

function Navigation(props: { isOpen: boolean; setOpen: (x: boolean) => void }) {
  const features = useFeatures();

  return (
    <React.Fragment>
      <button
        type="button"
        className={cx(
          s.navbarToggler,
          s.btn,
          s.uHamburger,
          props.isOpen ? null : s.collapsed,
        )}
        aria-label="Toggle navigation"
        aria-expanded={props.isOpen}
        aria-controls="navBar"
        onClick={() => props.setOpen(!props.isOpen)}
      >
        <span className={s.uHamburger__box}>
          <span className={cx(s.uHamburger__inner, spriv.hamburger)} />
        </span>
      </button>
      <div
        id="navBar"
        className={cx(
          s.collapse,
          s.navbarCollapse,
          spriv.collapse,
          props.isOpen ? s.show : null,
        )}
      >
        <ul className={cx(s.navbarNav)}>
          <HeaderItem>
            <Link to="/vendita/">Vendi</Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/valuta/">Valuta</Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/cerca/">Cerca</Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/cambia/">Cambia</Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/proprieta/" partiallyActive>
              Le nostre case
            </Link>
          </HeaderItem>
          {whenEnabled(features.market.linkedOnHeader, () => (
            <HeaderItem>
              <Link to="/mercato/">Mercato</Link>
            </HeaderItem>
          ))}
          <HeaderItem>
            <Link
              to="/blog/"
              partiallyActive={(() => {
                const pathName = globalHistory.location.pathname;
                if (pathName.includes("/blog/guide")) return false;
                if (pathName.includes("/blog")) return true;
              })()}
            >
              Blog
            </Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/blog/guide">Guide</Link>
          </HeaderItem>
          <HeaderItem>
            <Link to="/agenti/">Agenti</Link>
          </HeaderItem>
        </ul>
      </div>
    </React.Fragment>
  );
}
